import { FC } from "react";

/**
 * Right Arrow Icon Props Interface
 * @interface NextPageIconProps
 */
interface NextPageIconProps {
  color?: string
}

const NextPageIcon: FC<NextPageIconProps> = ({ color="#AAAAAA" }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6445 14.0303C10.3516 13.7374 10.3516 13.2626 10.6445 12.9697L13.8642 9.75L2.17481 9.75C1.76059 9.75 1.42481 9.41421 1.42481 9C1.42481 8.58578 1.76059 8.25 2.17481 8.25L13.8642 8.25L10.6445 5.03033C10.3516 4.73743 10.3516 4.26256 10.6445 3.96967C10.9374 3.67677 11.4123 3.67678 11.7052 3.96967L16.2051 8.46967C16.498 8.76256 16.498 9.23743 16.2051 9.53033L11.7052 14.0303C11.4123 14.3232 10.9374 14.3232 10.6445 14.0303Z"
        fill={color}
      />
    </svg>
  );
};

export default NextPageIcon;
